module.exports = __webpack_public_path__ + "static/media/video-mask-bcg.2f3883c7.jpg";